/**
 * @generated SignedSource<<70a9c59f25b0c8b3b7bacc60d05af3c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Filters$data = {
  readonly jira: {
    readonly hasIsFiltersExpanded?: "JiraQuery";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersForLanding">;
  readonly " $fragmentType": "Nav4Filters";
};
export type Nav4Filters$key = {
  readonly " $data"?: Nav4Filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Filters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isFiltersExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Filters",
  "selections": [
    {
      "condition": "isFiltersExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4FiltersForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isFiltersExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsFiltersExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "f71f6cd06a5f57478bea303bf60bd049";

export default node;
